export default function Disclaimer() {
  return (
    <>
      {/* ================= HERO SECTION ================= */}
      <section className="bg-[#0E1F3B]">
        <div className="max-w-7xl mx-auto px-6 py-20">
          <h1 className="text-4xl md:text-5xl font-playfair font-bold text-white">
            Disclaimer
          </h1>
          <p className="mt-4 text-gray-300 max-w-3xl leading-relaxed">
            Please read this disclaimer carefully before using this website.
          </p>
        </div>
      </section>

      {/* ================= CONTENT SECTION ================= */}
      <section className="bg-gray-50">
        <div className="max-w-5xl mx-auto px-6 py-20 space-y-8 text-gray-800 leading-relaxed">

          <p>
            In compliance with the rules of the Bar Council of India,
            <strong> Blackthorn Chambers</strong> maintains this website solely
            for informational and educational purposes.
          </p>

          <h2 className="text-2xl font-semibold text-[#123a6f]">
            No Advertisement or Solicitation
          </h2>
          <p>
            The Bar Council of India prohibits advocates and law firms from
            soliciting work or advertising in any form. Accordingly, nothing
            contained on this website shall be construed as an advertisement,
            solicitation, inducement, or invitation for the provision of legal
            services.
          </p>
          <p>
            The user acknowledges that they are accessing this website on their
            own initiative to obtain information about Blackthorn Chambers and
            its areas of practice. No material on this website has been created
            or published for the purpose of soliciting legal work.
          </p>

          <h2 className="text-2xl font-semibold text-[#123a6f]">
            No Legal Advice
          </h2>
          <p>
            The information provided on this website is for general
            informational purposes only and does not constitute legal advice,
            opinion, or recommendation. The content should not be relied upon
            as a substitute for professional legal consultation.
          </p>
          <p>
            Blackthorn Chambers disclaims all liability for any loss or damage
            arising from reliance on the information contained herein.
          </p>

          <h2 className="text-2xl font-semibold text-[#123a6f]">
            No Lawyer–Client Relationship
          </h2>
          <p>
            Accessing, browsing, or using this website, or contacting Blackthorn
            Chambers through this website, does not create a lawyer–client
            relationship. Such a relationship shall only be established through
            a formal engagement and written confirmation.
          </p>

          <h2 className="text-2xl font-semibold text-[#123a6f]">
            Accuracy of Information
          </h2>
          <p>
            While reasonable efforts are made to ensure that the information on
            this website is accurate and up to date, Blackthorn Chambers makes
            no warranties or representations regarding the completeness,
            accuracy, or reliability of any content.
          </p>

          <h2 className="text-2xl font-semibold text-[#123a6f]">
            Confidentiality
          </h2>
          <p>
            Users are advised not to send any confidential or sensitive
            information through this website. Any information sent prior to the
            establishment of a lawyer–client relationship shall not be treated
            as confidential.
          </p>

          <h2 className="text-2xl font-semibold text-[#123a6f]">
            Third-Party Links
          </h2>
          <p>
            This website may contain links to third-party websites for
            convenience or reference. Blackthorn Chambers does not endorse or
            assume responsibility for the content, accuracy, or security of
            such external websites.
          </p>

          <h2 className="text-2xl font-semibold text-[#123a6f]">
            Acceptance of Terms
          </h2>
          <p>
            By accessing and using this website, the user confirms that they
            have read, understood, and agreed to this Disclaimer and the
            applicable rules of the Bar Council of India.
          </p>

          <div className="pt-8 border-t border-gray-300">
            <p className="font-semibold text-gray-900">
              Blackthorn Chambers
            </p>
            <p className="text-sm text-gray-600">
              Advocates & Legal Consultants
            </p>
          </div>

        </div>
      </section>
    </>
  );
}
